<div class="dialog-content-wrapper edit-platform-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    @if (info) {
      <span class="title dialog-title">{{info.name}}</span>
    }
    <button mat-button class="mat-icon-button"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  <!--    </div>-->
</mat-toolbar>
@if (info) {
  <div class="m-0 content">
    @for (platform of info.matrixPlatform; track platform.id) {
      @if (platform.platform) {
        <div class="platform">
          <div class="platform-title">{{platform?.platform?.title}}</div>
          <div>
            <mat-checkbox [(ngModel)]="platform.enable"></mat-checkbox>
          </div>
        </div>
      }
    }
  </div>
}
<div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button class="mat-accent mr-16" (click)="edit()">{{'main.save' | translate}}</button>
  <button mat-button (click)="dialogRef.close(false)">{{'button.cancel' | translate}}</button>
</div>
</div>

